var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flag-container text-center"},[_c('b-img',{staticClass:"w-100",attrs:{"src":"/images/home-page/new-flag.svg"}}),_c('p',{staticClass:"flag-text text-white text-overline mb-0 w-100"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }